document.addEventListener("turbolinks:load", () => {
  const dataDestroy = document.querySelectorAll(
    'input[type="checkbox"][data-destroy]'
  );

  const updateHiddenField = (checked, target) => {
    if (checked) {
      target.value = "";
    } else {
      target.value = "1";
    }
  };

  if (dataDestroy.length > 0) {
    dataDestroy.forEach(function (checkbox) {
      const hiddenField = checkbox.parentElement.querySelector(
        'input[type="hidden"][name$="[_destroy]"]'
      );

      checkbox.addEventListener("change", (e) => {
        updateHiddenField(e.target.checked, hiddenField);
        console.log(hiddenField, hiddenField.value);
      });
    });
  }
});
